import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const API_BASE = 'https://css-67zw.onrender.com';


export default function UserDashboard({ auth }) {
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!auth) return;

    axios
      .get(`${API_BASE}/api/results/user/${auth.user.id}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`
        }
      })
      .then((res) => setResults(res.data))
      .catch((err) => {
        console.error(err);
        setError('Failed to load dashboard data');
      });
  }, [auth]);

  /* 🔎 Weak subject analysis */
  const subjectStats = {};
  results.forEach((r) => {
    r.wrongAnswers?.forEach((w) => {
      const subject = w.subject || 'General';
      subjectStats[subject] = (subjectStats[subject] || 0) + 1;
    });
  });

  /* 📊 Progress Graph Data */
  const chartData = {
    labels: results
      .slice()
      .reverse()
      .map((r) =>
        new Date(r.createdAt).toLocaleDateString()
      ),

          datasets: [
        {
          label: 'Score %',
          data: results
            .slice()
            .reverse()
            .map(r => Math.round((r.score / r.total) * 100)),

          borderColor: '#2563eb',
          backgroundColor: 'rgba(37, 99, 235, 0.15)',
          pointBackgroundColor: '#22c55e',
          pointBorderColor: '#fff',
          pointRadius: 6,
          pointHoverRadius: 8,
          fill: true,
          tension: 0.4
        }
      ]

  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          callback: (v) => v + '%'
        }
      }
    }
  };

  return (
  <div className="mcq-card fade-in">
    <h2>Your Performance Dashboard</h2>

    {/* STATS */}
    <div className="stats-grid">
      <div className="stat-card">
        <h4>Total Tests</h4>
        <p>{results.length}</p>
      </div>

      <div className="stat-card">
        <h4>Average Score</h4>
        <p>
          {results.length
            ? Math.round(
                (results.reduce(
                  (a, r) => a + r.score / r.total,
                  0
                ) /
                  results.length) *
                  100
              )
            : 0}
          %
        </p>
      </div>

      <div className="stat-card">
        <h4>Weak Areas</h4>
        <p>{Object.keys(subjectStats).length}</p>
      </div>
    </div>

    {/* 📊 PROGRESS GRAPH */}
    {results.length > 1 && (
      <div className="mcq-card fade-in" style={{ marginTop: 30 }}>
        <h3 className="section-title">Progress Over Time</h3>
        <Line data={chartData} options={chartOptions} />
      </div>
    )}

    {/* WEAK SUBJECTS */}
    <h3 className="section-title" style={{ marginTop: 30 }}>
      Weak Subjects
    </h3>

    {Object.keys(subjectStats).length === 0 ? (
      <p>No weak areas yet 🎯</p>
    ) : (
      <div className="subject-badges">
        {Object.entries(subjectStats).map(([s, c]) => (
          <span key={s} className="subject-badge">
            {s} — {c}
          </span>
        ))}
      </div>
    )}

    {/* TEST HISTORY */}
    <h3 className="section-title" style={{ marginTop: 30 }}>
      Previous Tests
    </h3>

    {results.length === 0 ? (
      <p>No tests attempted yet</p>
    ) : (
      <div className="test-history">
        {results.map((r) => (
          <div key={r._id} className="test-card">
            <div className="test-score">
              {r.score}/{r.total}
            </div>
            <div className="test-meta">
              {new Date(r.createdAt).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);


}
